import {Component} from "preact";
import outsideClick from "../../../utilities/outsideClick";

export class OutsideClickWrapper extends Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        watch: false,
        onOutsideClick: () => {}
    };

    render(props, state, context) {
        return props.children[0];
    }

    componentDidUpdate(previousProps, previousState, previousContext) {
        if (!previousProps.watch && this.props.watch) {
            setTimeout(() => {this.watchOutsideClick();});
        } else if (previousProps.watch && !this.props.watch) {
            this.stopWatchingOutsideClick();
        }
    }

    componentWillUnmount() {
        this.stopWatchingOutsideClick();
    }

    watchOutsideClick() {
        this.outsideClick = outsideClick(this.base, this.props.onOutsideClick)
    }

    stopWatchingOutsideClick() {
        if (this.outsideClick) this.outsideClick.off();
    }
}



// WEBPACK FOOTER //
// ./components/layout/outside-click-wrapper/index.js